<template>
    <tr
        v-if="isBeingEdited"
        class="kgr-table__row"
    >
        <td class="kgr-table__cell">
            {{ role.parameterValue.value }}
        </td>
        <td class="kgr-table__cell">
            <div class="form-widget without-label date-picker">
                <kgr-date-picker v-model="editRole.from" />
            </div>
        </td>
        <td class="kgr-table__cell">
            <div
                class="form-widget without-label date-picker"
                :class="{ invalid: !editRole.isValidDateRange() }"
            >
                <kgr-date-picker v-model="editRole.to" />
            </div>
        </td>
        <td class="kgr-table__cell">
            {{ departmentName }}
        </td>
        <td class="kgr-table__cell">
            {{ teamName }}
        </td>
        <td class="kgr-table__cell">
            <div class="form-widget without-label date-picker">
                <textarea
                    v-model.trim="editRole.notice"
                    class="kgr-input"
                    rows="3"
                ></textarea>
            </div>
        </td>
        <td class="kgr-table__cell kgr-table__cell--actions">
            <kgr-icon-edit
                :size="15"
                disabled
                class="kgr-table__action"
            />
            <kgr-icon-delete
                class="kgr-table__action"
                @click="$emit('remove')"
            />
        </td>
    </tr>
</template>

<script setup>
import ClubEmployeeRole from '../../../js/dto/ClubEmployeeRole';
import KgrDatePicker from '../../common/form/picker/DatePicker';
import KgrIconDelete from '../../common/icon/IconDelete';
import KgrIconEdit from '../../common/icon/IconEdit';
import { computed } from 'vue';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps({
    role: {
        type: ClubEmployeeRole,
        required: true,
    },
    editRoles: {
        type: Array,
        required: true,
    },
});

defineEmits(['remove']);

const editIndex = computed(() => props.editRoles.map(editRole => editRole.id).indexOf(props.role.id));
const isBeingEdited = computed(() => editIndex.value !== -1);
const editRole = computed(() => props.editRoles[editIndex.value]);
const departmentName = computed(() => (props.role.department ? props.role.department.name : ''));
const teamName = computed(() => (props.role.team ? props.role.team.name : ''));
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .date-picker {
        border: 1px solid transparent;

        &.invalid {
            border: 1px solid #F44336;
        }
    }
</style>
